// Gedeeld door CaseDetailDrawer en de eigen PDF-bon (src/CaseSummaryPdf).

export const formatDateTimestamp = (timestamp) => {
  try {
    const date = new Date(timestamp);
    return date.toLocaleString("nl-NL", {
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  } catch {
    return "N/A";
  }
};

export const formatDeliveryDate = (timestamp) => {
  try {
    const date = new Date(timestamp);
    return date
      .toLocaleDateString("nl-NL", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      })
      .replace(/-/g, "/");
  } catch {
    return "N/A";
  }
};

export const normalizeJaw = (jaw) => {
  if (!jaw || typeof jaw !== "string") return null;
  const s = jaw.toLowerCase().trim();

  if (["upper", "maxilla", "max"].includes(s)) return "Upper";
  if (["lower", "mandible", "mand"].includes(s)) return "Lower";
  if (["both", "upper+lower", "max+mand"].includes(s)) return "Both";

  return null;
};
